import Model from '@/models/Model';
import api from '@/services/Api';
import store from '@/store';

export default class OrderableModel extends Model {
    updateOrder (order, confirmMe) {
        if (!confirmMe || confirm(confirmMe)) {
            return api.put(`${this.route}/${this.id}/update-order`, { order }).then((response) => {
                response.data = this.constructor.map(response.data);
                store.commit(this.constructor.commitSet, response.data);
                return response;
            });
        }
        return Promise.reject(new Error('Not confirmed.'));
    }

    static get isOrdered () {
        return true;
    }
}
